import React from 'react';

/** The studio mark — the app icon itself. */
function Logo({ size = 38 }) {
  return (
    <img
      className="logo-mark"
      src="/icon.png"
      alt=""
      width={size}
      height={size}
      style={{ width: size, height: size }}
    />
  );
}

export default Logo;
